module.exports = __webpack_public_path__ + "static/media/rollover-report-icon.47175585.svg";